import { Routes, Route } from 'react-router-dom'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

// Pages
import LandingPage from '@pages/LandingPage'
import ShopPage from '@pages/ShopPage'
import ProductDetailPage from '@pages/ProductDetailPage'
import CartPage from '@pages/CartPage'
import CheckoutPage from '@pages/CheckoutPage'
import OrderSuccessPage from '@pages/OrderSuccessPage'
import LoginPage from '@pages/LoginPage'

// Admin
import AdminLayout from '@components/Admin/AdminLayout'
import AdminDashboard from '@pages/Admin/Dashboard'
import AdminProducts from '@pages/Admin/Products'
import AdminProductForm from '@pages/Admin/ProductForm'
import AdminOrders from '@pages/Admin/Orders'
import AdminOrderDetail from '@pages/Admin/OrderDetail'

// Components
import Navbar from '@components/Layout/Navbar'
import Footer from '@components/Layout/Footer'
import ProtectedRoute from '@components/Auth/ProtectedRoute'
import DemoBanner from '@components/UI/DemoBanner'

// Stripe
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '')

function App() {
  return (
    <Elements stripe={stripePromise}>
      <div className="app">
        <Navbar />
        <DemoBanner />
        <main>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/product/:slug" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order-success" element={<OrderSuccessPage />} />
            <Route path="/login" element={<LoginPage />} />

            {/* Admin Routes (nested under AdminLayout) */}
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="products/new" element={<AdminProductForm />} />
              <Route path="products/:id/edit" element={<AdminProductForm />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="orders/:id" element={<AdminOrderDetail />} />
            </Route>
          </Routes>
        </main>
        <Footer />
      </div>
    </Elements>
  )
}

export default App
